
export default function formCadastroDTO({
        nome, 
        nascimento, 
        email, 
        login, 
        senha, 
        celular,
        rua, 
        numero, 
        bairro, 
        complemento, 
        cep, 
        cidade,
        uf
    }){ 
        return{
        nome, 
        nascimento, 
        email, 
        login, 
        senha, 
        celular,
        rua, 
        numero, 
        bairro, 
        complemento, 
        cep, 
        cidade, 
        uf,
        acesso: 2,
        ativo: true
    }
}